"use client";

import useBreedGlossary from "@/domain/Breeds/useCases/useBreedGlossary";

import Container from "@/components/Container";
import ButtonGoToTop from "@/components/shared/ButtonGoToTop";
import FilterLetters from "@/components/shared/FilterLetters";
import IndexedList from "@/components/shared/IndexedList";
import SpecieCard from "./speciesCard";

import type { BreedListProps } from "./breedGlossary.types";

import s from "./breedGlossary.module.scss";

const BreedGlossary = ({ breeds }: BreedListProps) => {
  const { speciesBreeds, uniqueBreedLetters, handleLetterClick } =
    useBreedGlossary(breeds);

  return (
    <div className={s.box}>
      <Container>
        <h1 className={s.title}>Glossário de Raças</h1>
        <div className={s["species-card"]}>
          {speciesBreeds.map((item) => (
            <SpecieCard key={item.name} speciesType={item} />
          ))}
        </div>
        <FilterLetters
          avaibleLetters={uniqueBreedLetters}
          onClick={handleLetterClick}
        />
        <IndexedList
          items={breeds}
          getNameItem={(breed) => breed.name}
          getLinkItem={(breed) => `/racas/${breed.species}/${breed.slug}`}
          letterItems={uniqueBreedLetters}
        />
      </Container>
      <ButtonGoToTop size="md" variant="turquoise" iconRounded showMobile />
    </div>
  );
};
export default BreedGlossary;
